import { FC } from 'react';

import { useViewer } from '@treams/treams-hooks/useViewer';
import { GraphQLErrorMessage } from '@treams/treams-ui/common/GraphQLErrorMessage';

import { useGrowthPathContext } from '../contexts/GrowthPathContext';
import { growthPathDataMappingFromJobTitle } from '../GrowthPathConverter';
import { useGrowthPathJobTitleCompetenciesQuery } from '../hooks/useGrowthPathScale';
import GrowthPathDetailBody, { GrowthPathDetailBodySkeleton } from './GrowthPathDetailBody';
import LabelQueryWrapper from './LabelQueryWrapper';

const CareerDetailBody: FC = () => {
	const viewer = useViewer();

	const { jobTitleID, userID } = useGrowthPathContext();

	const { data, loading, error, scale } = useGrowthPathJobTitleCompetenciesQuery(
		{ id: jobTitleID, userID: userID ?? viewer!.id },
		{ skip: !jobTitleID || jobTitleID === 'all' },
	);

	const jobCompetencies = data?.jobTitle.competencies ?? [];

	if (loading) {
		return <GrowthPathDetailBodySkeleton />;
	}
	if (error) {
		return <GraphQLErrorMessage error={error.graphQLErrors[0]} />;
	}

	return (
		<LabelQueryWrapper jobCompetencies={jobCompetencies} data={data}>
			<GrowthPathDetailBody data={growthPathDataMappingFromJobTitle(data?.jobTitle, scale)} />
		</LabelQueryWrapper>
	);
};
export default CareerDetailBody;
